import clsx from 'clsx';
import AsideNavbar from 'src/components/AsideNavbar';
import PortalNavBar from 'src/components/PortalNavbar';
import styles from './styles.module.scss';

export const PageLayout = ({ children, className = '' }) => (
  <div className={clsx(styles.pageWrapper, className)}>
    <AsideNavbar />
    <div className={styles.pageContainer}>
      <div className={styles.contentWrapper}>
        <PortalNavBar className={styles.navBarOverride} />
        <div className={styles.contentContainer}>{children}</div>
      </div>
    </div>
  </div>
);
